import { encode } from "js-base64";
import { launchGame, launchTryGame, killPlayerUser } from "../api/game_gen";
import {
  setLocalStorage,
  getLocalStorage,
  setSesStorage,
  // removeLocalStorage,
} from "./auth.js";
import {
  isMobile,
  showDownloadDrawer,
  isInTelegramMobileApp,
  getShowGameLimitDialog,
} from "@/lobby_common/utils/utils.js";

import Store from "@/lobby_common/store/index";
import Router from "@/lobby_common/router/index";
import { eventPost, gtagGoogle } from "./eventFunction";
import { isGame, areObjectsEqual } from "@/lobby_common/utils/utils";
import { tgShareUrl } from "@/lobby_common/utils/utils";
import md5 from "md5";
// canTestPlay 'STATUS_BOOL_TRUE' 进入试玩 'STATUS_BOOL_FALSE' 或者其他值进入正式。
let isGoGame = false;
let vm = null;
let curGame = {};
export function sendPayGameThis(_this) {
  vm = _this;
}

const PayGame = async (gameGroupSid, more = {}) => {
  if (isGoGame === true || !gameGroupSid) {
    return false;
  }
  // 防止连续点击触发
  isGoGame = true;
  setTimeout(() => {
    isGoGame = false;
  }, 300);
  let {
    canTestPlay,
    replace,
    odds_style_id,
    isRoom,
    KillOffType,
    roomId,
    teamId,
    closeDialog,
    eid,
    isMatchKeys,
  } = more;

  if (canTestPlay === 1) {
    canTestPlay = "STATUS_BOOL_TRUE";
  }
  if (canTestPlay === 2) {
    canTestPlay = "STATUS_BOOL_FALSE";
  }

  const Gameboxlist = {
    gameGroupSid: gameGroupSid,
    canTestPlay: canTestPlay,
    isRoom,
  };
  let game_type = "";
  if (canTestPlay === "STATUS_BOOL_TRUE") {
    game_type = 2;
  }
  if (canTestPlay === "STATUS_BOOL_FALSE") {
    game_type = 1;
  }
  if (isRoom) {
    game_type = 3;
  }
  if (eid) {
    // 带eid的是点击游戏组件，不带的是跳转位置进来的
    eventPost("click", {
      eid: eid,
      gameGroupSid: gameGroupSid,
      isMatchKeys: isMatchKeys,
      time: Date.now(),
    });
  }
  eventPost("click_gameicon", {
    ...Gameboxlist,
    gameType: game_type,
    eid: eid,
    isMatchKeys: isMatchKeys,
  });
  // console.log("======= 11111111111 =========");
  if (showDownloadDrawer("H5_LIMIT_PLAY_GAME", closeDialog)) {
    return;
  }

  if (!KillOffType) {
    // 是否已经打开了当前游戏
    const currentGameStatus = getLocalStorage("currentGameStatus");
    if (
      currentGameStatus &&
      Object.prototype.toString.call(currentGameStatus) === "[object Object]"
    ) {
      curGame = {
        canTestPlay: Gameboxlist?.canTestPlay || "",
        isRoom: Gameboxlist?.isRoom || "",
        gameGroupSid: Gameboxlist.gameGroupSid,
      };
      if (
        areObjectsEqual(curGame, currentGameStatus) &&
        isGame() &&
        Store.getters.getShowTips
      ) {
        vm.$message.warning(vm.$t("Datalang.HomePage_TITLE_alreadyingaming"));
        return;
      }
    }
  }

  // Store.dispatch("setMenuBar", false);
  Store.commit("setogoLoading", true);
  if (Store.getters.taken) {
    try {
      const { code, data } = await killPlayerUser({});
      if (code === 0) {
        console.log("-----------data--------------", data);
        if (data.gameGroupSid !== "0") {
          Gameboxlist.gameGroupSid = data.gameGroupSid;
          curGame.gameGroupSid = Gameboxlist.gameGroupSid;
        }
      }
    } catch (error) {
      Store.commit("setogoLoading", false);
      throw error;
    }
  } else {
    Store.commit("setogoLoading", false);
  }

  if (KillOffType) {
    // 缓存 上次游戏未结束就退出  标识
    setSesStorage("lastGameNoEnd", true);
    // 是否已经打开了当前游戏
    const currentGameStatus = getLocalStorage("currentGameStatus");
    if (
      currentGameStatus &&
      Object.prototype.toString.call(currentGameStatus) === "[object Object]"
    ) {
      if (
        areObjectsEqual(curGame, currentGameStatus) &&
        isGame() &&
        Store.getters.getShowTips
      ) {
        Store.commit("setogoLoading", false);
        vm.$message.warning(vm.$t("Datalang.HomePage_TITLE_alreadyingaming"));
        return;
      }
    }
  }

  if (!getLocalStorage("isTour")) {
    setLocalStorage("isTour", "isShow");
  }

  const lang = Store.getters.getLang;

  // && canTestPlay !== 1 // 真玩模式判断是否登录
  if (!Store.getters.taken && canTestPlay !== "STATUS_BOOL_TRUE") {
    vm.$Bus.$emit("showLogin");
    return;
  }
  Store.commit("setPageLoding", true);

  // const GAMETYPE = window.localStorage.getItem("GAMETYPE");
  // const GameboxId = {};
  // if (GAMETYPE === "false") {
  //   GameboxId = getLocalStorage("GameboxId")[0] || {};
  // }
  //  是否是试玩
  let getGameLunchFun = launchGame;
  console.log(canTestPlay, isRoom, "===========================");
  if (canTestPlay === "STATUS_BOOL_TRUE" && !isRoom) {
    getGameLunchFun = launchTryGame; // 登录玩家走的接口
  }

  // 这里逻辑是走马甲包有参数就做判断终端
  // 设备
  const initQuery =
    JSON.parse(JSON.stringify(getLocalStorage("initQuery"))) || {};
  const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
  let clientType = "";

  // 特殊处理,判断app里面试玩, 就走h5 类型,不然直接调用试玩会走不通
  if (isFromApp && canTestPlay !== "STATUS_BOOL_TRUE") {
    clientType = initQuery.ft;
  } else {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (!Store.getters.getIsMobile) {
      clientType = "CLIENT_TYPE_WEB";
    }
    if (isAndroid) {
      clientType = "CLIENT_TYPE_ANDROID";
    }
    if (isIOS) {
      clientType = "CLIENT_TYPE_IOS";
    }
  }

  try {
    const args = {
      gameGroupSid: Gameboxlist.gameGroupSid,
      language: lang,
      clientType: clientType,
      roomId: roomId,
      teamId: teamId,
    };
    // 是否是 创房模式
    if (isRoom) {
      args.canNewRoom = "STATUS_BOOL_TRUE";
    }
    // bit  游戏盘id 类型
    if (odds_style_id) {
      args.odds_style_id = odds_style_id;
    }
    // TG分享地址
    args.shareUrlTg = await tgShareUrl();
    const { code, data } = await getGameLunchFun(args);
    if (code === 0) {
      try {
        vm.$Bus.$emit("rewardTipsclose");
      } catch (err) {
        console.log("捕获到错误：", err.message);
      }

      // 是否支持全屏
      const canWindow =
        data.canWindow === "STATUS_BOOL_TRUE" &&
        Store.getters.getPacketConfig?.packetInfo?.config?.canWindow ===
          "STATUS_BOOL_TRUE";

      // const gamePath = canWindow ? "/games/" : "/other/";
      const gamePath = "/games/";
      let path = "";
      if (isMobile() || isInTelegramMobileApp()) {
        if (data.isSelfStudy === "BRAND_RD_TYPE_SELF_STUDY") {
          // 是否自研
          path = "/payGame/";
        } else {
          path = "/other/";
        }
      } else {
        path = gamePath;
      }
      // PC 非全屏化 使用 games
      const fullLayoutGame = !canWindow && !isMobile();
      // 全局缓存
      Store.commit("setFullLayoutGame", fullLayoutGame);

      // 是否开启PC窗口化
      setLocalStorage("GameBroadId", canWindow ? true : "");
      const appUrl = encode(window.BASEAPI.baseApi.split("//")[1]); // 域名地址
      const token = Store.getters.taken ? encode(Store.getters.taken) : ""; // 登录后的token
      const version = encode(window.BASEAPI.VUE_APP_VERSION); // 版本，这个可以填可以不填
      const user_data = getLocalStorage("USER_DATA") || {};
      const user_id = user_data?.id ? md5(user_data?.id) : "";
      const app_deviceId = user_id ? encode(user_id) : ""; // 游戏要用的唯一标识
      // const terminaltype = localStorage.getItem("terminaltype") || "";
      // const close_full =
      //   isFromApp === true || terminaltype !== "normal" ? 1 : 0;
      // "&close_full=" +
      // close_full +
      // const isSelfStudy =
      //   data.isSelfStudy === "BRAND_RD_TYPE_THIRD" ? "2" : "1"; // 是否三方
      const isSelfStudy = data.launchUrl.includes("<!DOCTYPE html>")
        ? "2"
        : "1"; // 是否三方pg,返回的是html
      const launchUrl =
        data.launchUrl +
        "&lobby_web=100" +
        "&lobby_url=" +
        appUrl +
        "&app_version=" +
        version +
        "&app_deviceId=" +
        app_deviceId;

      const isOtherGame = data.isSelfStudy === "BRAND_RD_TYPE_THIRD" ? 1 : "";
      const urlpath =
        path +
        Gameboxlist.gameGroupSid +
        "?brand=" +
        isSelfStudy +
        "&other_game=" +
        isOtherGame +
        `&full=${fullLayoutGame ? "1" : ""}` +
        `&coin_code=${data.gameCoinCode || ""}` +
        `&is_show=${data.needPopExperienceLimit || ""}` +
        "&t=" +
        Date.now();

      // setLocalStorage("gameUrl", launchUrl);
      setLocalStorage("currentGameStatus", curGame);
      let gameId = Gameboxlist.gameGroupSid;
      if (isSelfStudy === "2") {
        // args
        gameId = data.thirdGameId;
        setLocalStorage("gameHtml", data.launchUrl);
      } else {
        setLocalStorage("gameUrl", launchUrl);
        // 创建一个 URL 对象
        const urlObj = new URL(data.launchUrl);
        // 使用 URLSearchParams 获取查询参数
        const launchUrlParams = new URLSearchParams(urlObj.search);
        // 获取game_id
        // const gameId = launchUrlParams.get("game_id");
        gameId = launchUrlParams.get("game_id");
      }

      eventPost("get_gameurl_success", {
        ...curGame,
        gameType: game_type,
        gameId: data.gameSid,
      });
      vm.$Bus.$emit("changeSearchDrawer", false); // 关闭全局搜索
      vm.$isPopShow({ show: false, views: "hotNew" }); //
      window.sessionStorage.setItem("freeBetPopConfirm", "false"); // 重置游戏内提现弹窗状态
      // Google进入游戏
      gtagGoogle("level_start");
      if (replace || isGame()) {
        Router.replace(urlpath);
      } else {
        Router.push(urlpath);
      }
    } else {
      // console.log("===code,data===", code, data);
      if (
        Number(code) === 1090170 ||
        Number(code) === 1090121 ||
        Number(code) === 1090177
      ) {
        // 1090170; // 游戏限制错误
        // 1090121; // 游戏限制错误
        // 1090177; // 游戏限制充值真实钱包金额错误
        const limitType = Number(code) === 1090177 ? "balanceLimit" : "";
        getShowGameLimitDialog(Gameboxlist.gameGroupSid, limitType);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    Store.commit("setPageLoding", false);
    Store.commit("setogoLoading", false);
  }
};

export default PayGame;
